module.exports = __webpack_public_path__ + "img/gallery18.67fed84e.png";